<template>
  <UiCard class="ui-navigation-card-image">
    <UiImg :src="src" :alt="alt" :width="width" :height="height" />
  </UiCard>
</template>

<script setup lang="ts">
import { UiImg, UiCard } from '~/ui';

export interface Props {
  src: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
}

withDefaults(defineProps<Props>(), {
  alt: 'image',
  width: 84,
  height: 60,
});
</script>

<style lang="scss">
.ui-navigation-card-image {
  box-shadow: none;
  border-radius: 0;
  padding: 17px 13px 6px;
  img {
    display: block;
  }
}
</style>
